
export default () => ({
  jobs: [],
  pagination: null,
  currentPage: 1,
  jobCategory: [],
  search: '',
  loading: false,
  orderBy: 'desc',
  init() {
    this.initParams();
    this.fetchJobs();
  },
  initParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const jobCategories = urlParams.getAll('jobCategory');
    const q = urlParams.get('q');
    if (jobCategories) {
      jobCategories.forEach(category => {
        this.jobCategory.push(parseInt(category));
      });
    }
    if (q) {
      this.search = q;
    }
  },
  async fetchJobs() {
    const params = new URLSearchParams({
      page: this.currentPage,
      jobCategory: this.jobCategory,
      q: this.search,
      orderBy: this.orderBy,
    });
    const url = `/${document.documentElement.lang}/jobs.json?${params}`;
    this.loading = true;
    const response = await fetch(url);
    this.loading = false;
    const data = await response.json();
    this.jobs = this.jobs.concat(data.data);
    this.pagination = data.meta.pagination;
  },
  nextPage() {
    this.currentPage += 1;
    this.fetchJobs();
  },
  filterChange() {
    this.jobs = [];
    this.currentPage = 1;
    this.fetchJobs();
  }
});